module.exports = "pegasus_template/assets/theme3/small/4.jpg";